import { useEffect } from "react";

const GoogleTranslate = () => {
  useEffect(() => {
    // Set configuration globally
    window.gtranslateSettings = {
      default_language: "en",
      languages: ["en", "fr", "it", "es", "de", "nl", "pl", "zh-CN"],
      wrapper_selector: ".gtranslate_wrapper",
      flag_style: "3d",
    };

    // Load the GTranslate script
    const script = document.createElement("script");
    script.src = "https://cdn.gtranslate.net/widgets/latest/float.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Optional cleanup
      document.body.removeChild(script);
    };
  }, []);

  return <div className="gtranslate_wrapper"></div>;
};

export default GoogleTranslate;
